<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 1.56987C12 0.702839 11.2972 0 10.4301 0H1.56987C0.702839 0 0 0.702839 0 1.56987V10.4301C0 11.2972 0.702839 12 1.56987 12H10.4301C11.2972 12 12 11.2972 12 10.4301V1.56987ZM9.18277 8.64516H2.86019C2.5929 8.64516 2.37632 8.42858 2.37632 8.16129C2.37632 7.894 2.5929 7.67742 2.86019 7.67742H9.18277C9.45006 7.67742 9.66664 7.894 9.66664 8.16129C9.66664 8.42858 9.45006 8.64516 9.18277 8.64516ZM9.18277 6.3871H2.86019C2.5929 6.3871 2.37632 6.17052 2.37632 5.90323C2.37632 5.63594 2.5929 5.41935 2.86019 5.41935H9.18277C9.45006 5.41935 9.66664 5.63594 9.66664 5.90323C9.66664 6.17052 9.45006 6.3871 9.18277 6.3871ZM9.18277 4.32258H4.34406C4.07677 4.32258 3.86019 4.106 3.86019 3.83871C3.86019 3.57142 4.07677 3.35484 4.34406 3.35484H9.18277C9.45006 3.35484 9.66664 3.57142 9.66664 3.83871C9.66664 4.106 9.45006 4.32258 9.18277 4.32258Z" fill="#B8CDD7"/>
</svg>

</template>

<script>
export default {

}
</script>

<style>

</style>